import { SET_NAVBAR } from '../../actions/types'

const INITIAL_STATE = 'home'

const navbar = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case SET_NAVBAR:
      return action.navbar
    default:
      return state
  }
}

export default navbar



// WEBPACK FOOTER //
// ./src/reducers/navbar/index.js